<template>
    <div>
        <router-view
            class="pt-2"
            :global-settings-information="cGlobalSettingsInformation" />
    </div>
</template>

<script lang="ts" setup>
const store = $store()

onMounted(() => {
  useRouter().push({ name: 'trucker-id-company-global-settings-general' })
})

const cGlobalSettingsInformation = computed(() => {
  return store.globalSettings.getGlobalSettings
})
</script>
